import api from '../../util/apiTradevine'

const state = {
  orders: [],
}

const getters = {
  orders: (state) => {
    return state.orders
  },
}

const actions = {
  getOrders({ commit, dispatch }) {
    api
      .getCollectionOrders()
      .then((response) => {
        commit('setOrders', response.data.List)
      })
      .catch((e) => {
        dispatch('handleError', e, { root: true })
      })
  },
}

const mutations = {
  setOrders(state, orders) {
    state.orders = orders
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
